const messages = {
  title: 'Toegang geweigerd',
  description: 'U hebt geen toegang tot deze bron.',
  backHomeButton: 'Terug naar dashboard'
}

export default {
  messages
}
